import React, { PureComponent } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import InputNumber from '../../commons/form/InputNumber'
import { isJsonString, handleKeyDown } from '../../../util/utils'

class SignatureEntityMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.signatureEntity)
    }
  }

  submitSignatureEntity (values) {
    const signatureEntity = {
      order: values.order,
      signTypeId: values.signTypeId,
      signEntityTypeId: values.signEntityTypeId,
      coordinatePages: values.coordinatePages,
      signEntityId: this.props.signatureEntity?.signEntityId,
      signDocumentConfigurationId: this.props.signatureEntity?.signDocumentConfigurationId
    }
    this.props.actions.submitSignatureEntity(signatureEntity)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { signTypeCombo, signEntityTypeCombo },
      actions: {
        closeSignatureEntityMasterModal
      }
    } = this.props
    const tKey = 'MASTERS.SIGNATURE_CONFIG_MASTERS.MODAL.'

    return (
      <Modal
        id="signatureEntityMasterModal"
        className="_nf"
        show={showModal}
        onHide={closeSignatureEntityMasterModal}
        backdrop={'static'}>
        <form autoComplete="off"
          onSubmit={handleSubmit(this.submitSignatureEntity.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header
            closeButton
            onHide={closeSignatureEntityMasterModal}
          >
            <Modal.Title>{t(`${tKey}SIGN_ENTITY`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputNumber}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="order"
                name="order"
                controlLabel={t(`${tKey}ORDER`)}
                placeholder={t(`${tKey}ORDER`)}
                valueKey="id"
                labelKey="value"

                colSm={0}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="signTypeId"
                controlLabel={t(`${tKey}SIGNATURE_TYPE`)}
                placeholder={t(`${tKey}SIGNATURE_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={signTypeCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="signEntityTypeId"
                controlLabel={t(`${tKey}SIGNATURE_ENTITY_TYPE`)}
                placeholder={t(`${tKey}SIGNATURE_ENTITY_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={signEntityTypeCombo}
              />
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="coordinatePages"
                name="coordinatePages"
                controlLabel={t(`${tKey}ADVANCED_OPTIONS`)}
                placeholder={t(`${tKey}ADVANCED_OPTIONS`)}
              />

            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
              <Button
                id="role-modal-submit-button"
                className="_Btn cancel"
                type="reset"
                onClick={closeSignatureEntityMasterModal}
              >
                {t(`${tKey}CANCEL_BUTTON`)}
              </Button>

            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editSignatureEntity',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.SIGNATURE_CONFIG_MASTERS.VALIDATION.'
    if (!values.coordinatePages) {
      error.coordinatePages = props.t(`${tKey}ADVANCED_OPTIONS_REQUIRED`)
    }
    if (values.coordinatePages && !isJsonString(values.coordinatePages)) {
      error.coordinatePages = props.t(`${tKey}ADVANCED_OPTIONS`)
    }
    if (!values.order) {
      error.order = props.t(`${tKey}ORDER`)
    }
    if (!values.signEntityTypeId) {
      error.signEntityTypeId = props.t(`${tKey}SIGN_ENTITY_TYPE`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(SignatureEntityMasterModal)
